var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.applicationPendingWidget,{tag:"component"}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"home col-xs-12 col-lg-8",attrs:{"id":"content"}},[_c(_vm.component,{tag:"component"})],1),_c('sidebar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }